import React from 'react';
import { Card, Table, Tag } from 'antd';

const CategoryDataTable = ({ data }) => {
  // Helper function to safely get data from different possible structures
  const getCoursesByCategory = () => {
    if (!data) return [];
    
    // Try different possible data structures
    const paths = [
      'coursesByCategory',
      'data.coursesByCategory',
      'overview.coursesByCategory',
      'data.overview.coursesByCategory'
    ];
    
    for (const path of paths) {
      const value = path.split('.').reduce((obj, key) => obj?.[key], data);
      if (value && Array.isArray(value) && value.length > 0) {
        return value;
      }
    }
    
    return [];
  };

  const getTotalCourses = () => {
    if (!data) return 0;
    
    // Try different possible data structures
    const paths = [
      'overview.totalCourses',
      'data.overview.totalCourses',
      'totalCourses',
      'data.totalCourses'
    ];
    
    for (const path of paths) {
      const value = path.split('.').reduce((obj, key) => obj?.[key], data);
      if (value !== undefined && value !== null) {
        return value;
      }
    }
    
    return 0;
  };

  const coursesByCategory = getCoursesByCategory();
  const totalCourses = getTotalCourses();

  if (coursesByCategory.length === 0) {
    return (
      <Card title="Category Details" className="chart-card">
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <div style={{ color: '#999', padding: '40px 0' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📋</div>
            <p>No category data available yet</p>
            <p style={{ fontSize: '12px' }}>Category data will appear here when courses are created</p>
          </div>
        </div>
      </Card>
    );
  }

  // Chuẩn bị dữ liệu cho bảng
  const tableData = coursesByCategory
    .sort((a, b) => b.courseCount - a.courseCount)
    .map((category, index) => ({
      key: category._id,
      rank: index + 1,
      name: category.categoryName,
      slug: category.categorySlug,
      courseCount: category.courseCount,
      percentage: totalCourses > 0 ? ((category.courseCount / totalCourses) * 100).toFixed(1) : '0.0'
    }));

  const columns = [
    {
      title: 'Rank',
      dataIndex: 'rank',
      key: 'rank',
      width: 80,
      render: (rank) => (
        <Tag color={rank <= 3 ? '#52c41a' : '#d9d9d9'}>
          #{rank}
        </Tag>
      )
    },
    {
      title: 'Category Name',
      dataIndex: 'name',
      key: 'name',
      render: (name) => <strong>{name}</strong>
    },
    {
      title: 'Slug',
      dataIndex: 'slug',
      key: 'slug',
      render: (slug) => <code>{slug}</code>
    },
    {
      title: 'Courses',
      dataIndex: 'courseCount',
      key: 'courseCount',
      width: 100,
      render: (count) => (
        <Tag color="blue">{count}</Tag>
      )
    },
    {
      title: 'Percentage',
      dataIndex: 'percentage',
      key: 'percentage',
      width: 120,
      render: (percentage) => (
        <span style={{ color: '#666' }}>{percentage}%</span>
      )
    },
    // Removed Actions column to save space
  ];

  return (
    <Card title="Category Details" className="chart-card">
      <div className="fixed-table">
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={false}
          size="small"
          scroll={{ x: 600, y: 350 }}
        />
      </div>
    </Card>
  );
};

export default CategoryDataTable; 